import React, { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, CircularProgress, Link, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { switchProgress, useDataSetSwitch } from 'context/data-set-switch';

/**
 * Shown in the app bar while a data set switch runs, so it stays visible on
 * every page. Links to the Test data tab, which has the details.
 */
const DataSetSwitchIndicator: FC = () => {
    const { t: translate } = useTranslation(['app-settings']);
    const { status, isRunning } = useDataSetSwitch();

    if (!status || !isRunning) return null;

    const progress = switchProgress(status);
    const dataSet =
        status.dataSet === 'PRODUCTION_COPY'
            ? translate('app-settings:DATA_SET_PRODUCTION_COPY')
            : translate('app-settings:DATA_SET_REGRESSION');

    return (
        <Link
            component={RouterLink}
            to="/app-settings/db-switch"
            color="inherit"
            underline="none"
            data-test="data-set-switch-indicator"
        >
            <Box display="flex" alignItems="center" mr={3}>
                <CircularProgress
                    color="inherit"
                    size={16}
                    variant={progress === undefined ? 'indeterminate' : 'determinate'}
                    value={progress}
                    sx={{ mr: 1 }}
                />
                <Typography variant="body2">
                    {progress === undefined
                        ? translate('app-settings:DATA_SET_SWITCH_INDICATOR', { dataSet })
                        : translate('app-settings:DATA_SET_SWITCH_INDICATOR_PERCENT', { dataSet, progress })}
                </Typography>
            </Box>
        </Link>
    );
};

export default DataSetSwitchIndicator;
